"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react");exports.default=r=>{e.useEffect(r,[])};
//# sourceMappingURL=useEffectOnce.js.map
